import AbstractFilterDefinition from './AbstractFilterDefinition.js'

export default class RelatedTypesFilterDefinition extends AbstractFilterDefinition
{
    constructor(name, label) {
        super(name, label);
    }

    get component() {
        return 'checkbox-filter';
    }

    dataAdapter(data) {
        switch (data.mode) {
            case 'is':
                if (data.choices.length == 0) {
                    return null;
                }
                return {'match': data.choices};
            case 'known':
                return {'match': ['opportunity', 'document']};
            case 'unknown':
                return {'not_match':  ['opportunity', 'document']};
        }
    }
    get configuration() {

        const configuration =  {
            "choices": {
                "name": "choices",
                "type": "checkbox",
                "options": {
                    oportunity: { value: 'opportunity', label: i18n.__("Opportunité"), rank: 0 },
                    document: { value: 'document', label: i18n.__("Document"), rank: 0 }
                }
            },
            "mode": {
                "type": "radio",
                "name": "mode",
                "options": {
                    "known": {
                        "value": "known",
                        "label": i18n.__("Est connu")
                    },
                    "unknown": {
                        "value": "unknown",
                        "label": i18n.__("Est inconnu")
                    },
                    "is": {
                        "default": true,
                        "value": "is",
                        "label": i18n.__("Est du type")
                    },
                }
            }
        };
        return configuration;
    }
}